import { createFileRoute } from "@tanstack/react-router";
import { QuickRegistration } from "../app/features/registration/quickRegistration";

export const Route = createFileRoute("/quickRegistration")({
  component: QuickRegistration,
});
